export default __webpack_public_path__ + "static/media/moon.8ddbc237.jpg";